// custom scripts
// mcs 2023



// WINDOW SCROLLED
$(window).scroll(function() {  

  
  var scroll = $(window).scrollTop();
  if (scroll >= 200) {
      $("body").addClass("scrolled");
  } else {
      $("body").removeClass("scrolled");
  }
  if (scroll >= 500) {
      $("body").addClass("scrolled2");
  } else {
      $("body").removeClass("scrolled2");
  }
  if (scroll >= 20) {
      $("body").addClass("first-scrolled");
  } else {
      $("body").removeClass("first-scrolled");
  }

  
});



$(document).ready(function() {


  //console.log( "ready!" );
  $('body').addClass('ready');
  setTimeout(function(){
    $('body').addClass('ready2');
  }, 1000);
  setTimeout(function(){
    $('body').addClass('ready3');
  }, 3000);


  // $('body').hide();


  
  
    

}); // clode doc ready











$(window).on('load', function() {



});

















